export default __webpack_public_path__ + "static/media/02_drevorubecke-kleste.5f6a2e45.jpg";